import {
  Row,
  Col,
  Form,
  Input,
  Select,
  Button,
  Menu,
  Checkbox,
  Table,
  Tag,
  Space,
  Modal,
  notification,
  Empty,
} from 'antd'

import React, { useState, useEffect } from 'react'

import styled from 'styled-components'
import ColorList from 'constants/color.constants'
import {
  PlusOutlined,
  LeftOutlined,
  SaveOutlined,
  CheckCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  CloseCircleOutlined,
  CopyOutlined,
} from '@ant-design/icons'
import bin from 'icons/createproject/Subtask.svg'
import moment from 'moment'
const Bodier = styled.div``

import SubInformation from './Information/subtaskinformation'
import SubAssignee from './Assignee/subtaskassignee'
import SubSupportNeed from './SupportNeed/subtasksupportneed'
import SubKPIFinance from './KPIFinance/subtaskkpifinance'
import SubChecklist from './Checklist/subchecklist'

import {
  getResultSubTask,
  deleteSprintFlow,
  copyTask,
  getResultProjectList,
} from 'api/Project/sprintFlow'
import { getCookie } from 'helper/cookie'
import 'styleLess/signature/sprintTaskFlow.scss'

import { postSpintflowinit } from 'api/Project/sprintFlow'
import { useForm } from 'antd/lib/form/Form'

import ModalCopy from 'common/Project/modalCopy'

import lang from 'lang/en'

//url
import { useParams } from 'react-router-dom'
import { useHistory } from 'react-router-dom'
import Dependencies from './Dependencies/dependencies'

const Container = styled.div`
  background-color: ${ColorList.white};
  width: 100;
  height: auto;
`

const initialState = {
  switchAddTaskComponents: 'subinformation',
  syncFuntion: '',
  nowState: 'information',
  data: [],
  isLoading: true,
}

let canclemodal = 0

const CreateProjectStep6 = (props) => {
  ///lang
  const language = getCookie('lang')
  const word = lang[language]

  const token = getCookie('access_token_admin')

  const [isLoading, setIsLoading] = useState(initialState.isLoading)
  const {
    swithCaseTaskFLowFunction,
    role,
    idEditPRJ,
    statusProject,
    roleold,
    canKPIFinance,
    memberRole,
    checkCanEditProjectByStatus,
    checkPlandateTaskSubTask,
    checkStatusWaiting,
    checkChangeFlow,
    setCheckChangeFlow,
    fullyCheckComplete,
  } = props
  const [form] = Form.useForm()

  //add subtask
  const [ModalVisionAddTask, setModalVisionAddTask] = useState(false)
  const [checkbtn, setCheckbtn] = useState()
  const [showCode, setShowCode] = useState()

  //init subtask
  const [ModalVisionAddTitle, setModalVisionAddTitle] = useState(false)
  const [idsubtask, setIDSubtask] = useState('dis')

  //data sub task
  const [dataSubTask, setDataSubTask] = useState(initialState.data)

  //data task
  const [dataTask, setDataTask] = useState(initialState.data)

  //delete sub task
  const [visibleModalDelete, setVisibleModalDelete] = useState()
  const [dataDelete, setDataDelete] = useState()

  const [changePageInformation, setChangePageInformation] = useState(true)
  const [changePageInformation2, setChangePageInformation2] = useState(true)

  //modal Copy
  const [visibleModalCopy, setVisibleModalCopy] = useState(false)
  const [dataCopy, setDataCopy] = useState()

  //url
  const history = useHistory()
  const { id } = useParams()
  const [checkLanding, setCheckLanding] = useState(false)

  const [rolee, setrolee] = useState(roleold)

  //namesubtask
  const [nameSubTask, setNameSubTask] = useState()
  const [subTaskStatus, setSubTaskStatus] = useState('')

  const urlPage2 = window.location.href
  const checkLandingPage = () => {
    const urlPage = window.location.href
    const split = urlPage.split('/')
    let landing = ''

    if (split[8]) {
      landing = split[8]
      // console.log(landing)
      setIDSubtask(parseInt(landing))

      if (landing !== '') {
        if (checkLanding == false) {
          Setmode(true)
          setOneUnitFocus(1)
          swithCaseAddTaskFunction('')
        }
      }

      setModalVisionAddTask(true)

      getResultProjectList({
        project_id: parseInt(idEditPRJ),
        id_chart: landing,
        token: token,
      })
        .then(async (response) => {
          const { status, data, error } = response

          if (error) {
            // await setDataSubTask([])
            setIsLoading(false)
            return true
          }
          if (status === 200) {
            // console.log(data)
            setShowCode(data.code)
            if (split[9]) {
              landing = split[9]
              if (landing === 'information') {
                Setmode(true)
                setOneUnitFocus(1)
                swithCaseAddTaskFunction('')
              } else if (landing === 'checklist') {
                Setmode(true)
                setOneUnitFocus(2)
                swithCaseAddTaskFunction('subchecklist')
              } else if (landing === 'assignee') {
                Setmode(true)
                setOneUnitFocus(3)
                swithCaseAddTaskFunction('subassignee')
              } else if (landing === 'supportneed') {
                Setmode(true)
                setOneUnitFocus(4)
                swithCaseAddTaskFunction('subsupportneed')
              } else if (landing === 'kpi') {
                Setmode(true)
                setOneUnitFocus(5)
                swithCaseAddTaskFunction('subkpifinance')
              } else if (landing === 'dependencies') {
                Setmode(true)
                setOneUnitFocus(7)
                swithCaseAddTaskFunction('dependencies')
              }
              setCheckLanding(true)
            }
          } else {
            // setDataSubTask([])

            setIsLoading(false)
            return true
          }
        })
        .catch((error) => {
          // setDataSubTask([])
          setIsLoading(false)
          console.error(error)
        })
    }
  }
  useEffect(() => {
    if (checkLanding === false || checkLanding === 'changeURL') {
      checkLandingPage()
    }
  }, [checkLanding])

  useEffect(() => {
    setCheckLanding('changeURL')
  }, [urlPage2])

  const openNotificationWithIcon = (type) => {
    // console.log(dataPermission)

    notification[type]({
      message: 'Warning',
      description: 'Please save your information.',
      duration: 3,
    })
  }

  const NoticicationTaskDate = (type) => {
    // console.log(dataPermission)

    notification[type]({
      message: 'Warning',
      description: 'Please input your task plan date.',
      duration: 5,
    })
  }

  //init sub task
  const EventUseModalAddTitle = () => {
    form.setFieldsValue({
      namesubtask: null,
    })
    setModalVisionAddTitle(true)
  }

  const handleOkAddTitle = (values) => {
    setModalVisionAddTitle(false)
    const dataArray = {
      project_id: parseInt(idEditPRJ),
      id_chart: props.funcsetIdChart + '_sub',
      title: values.namesubtask,
      level: 2,
      level_id: props.id,
    }
    try {
      postSpintflowinit({
        params: dataArray,
        token: token,
      }).then((response) => {
        const { status, data, error } = response
        if (error) {
          // props.setCode([])
          setIsLoading(false)
          return true
        }
        if (status === 200) {
          getDataSubTask()
          checkPlandateTaskSubTask()
          setIsLoading(false)
        } else {
          props.setCode([])
          // setIsLoading(false)
          return true
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  const handleCancelAddTitle = () => {
    setModalVisionAddTitle(false)
  }

  //add sub task
  const EventUseModal = (record, disabled) => {
    if (disabled == true) {
      if (roleold == true || disabled == true) {
        setrolee(true)
      }
    }
    Setmode(true)
    setOneUnitFocus(1)
    swithCaseAddTaskFunction('')
    setModalVisionAddTask(true)
    setIDSubtask(record.id)
    setShowCode(record.code)
    history.push(
      `/project/${id}/sprintflow/${props.funcsetIdChart}/subtask/${record.id}/information`,
    )
  }
  const handleOkAddTask = () => {
    // canclemodal = canclemodal + 1
    getDataSubTask()
    setModalVisionAddTask(false)
  }

  const handleCancelAddTask = () => {
    setrolee(roleold)
    // console.log(checkbtn)
    if (checkbtn === '' || checkbtn === undefined) {
      // canclemodal = canclemodal + 1
      setModalVisionAddTask(false)
    }
    history.push(`/project/${id}/sprintflow/${props.funcsetIdChart}/subtask`)
  }

  //menu add sub task
  const [mode, Setmode] = useState(true)
  const [OneUnitFocus, setOneUnitFocus] = useState(1)

  const handleSelect = (check) => {
    if (changePageInformation == false || changePageInformation2 == false) {
      openNotificationWithIcon('warning')
    } else {
      if (check == 1) {
        Setmode(true)
        setOneUnitFocus(1)
        swithCaseAddTaskFunction('')
        history.push(
          `/project/${id}/sprintflow/${props.funcsetIdChart}/subtask/${idsubtask}/information`,
        )
      }
      if (check == 2) {
        Setmode(true)
        setOneUnitFocus(2)
        swithCaseAddTaskFunction('subchecklist')
        history.push(
          `/project/${id}/sprintflow/${props.funcsetIdChart}/subtask/${idsubtask}/checklist`,
        )
      }
      if (check == 3) {
        Setmode(true)
        setOneUnitFocus(3)
        swithCaseAddTaskFunction('subassignee')
        history.push(
          `/project/${id}/sprintflow/${props.funcsetIdChart}/subtask/${idsubtask}/assignee`,
        )
      }
      if (check == 4) {
        Setmode(true)
        setOneUnitFocus(4)
        swithCaseAddTaskFunction('subsupportneed')
        history.push(
          `/project/${id}/sprintflow/${props.funcsetIdChart}/subtask/${idsubtask}/supportneed`,
        )
      }

      if (check == 5) {
        Setmode(true)
        setOneUnitFocus(5)
        swithCaseAddTaskFunction('subkpifinance')
        history.push(
          `/project/${id}/sprintflow/${props.funcsetIdChart}/subtask/${idsubtask}/kpi`,
        )
      }
      if (check == 7) {
        Setmode(true)
        setOneUnitFocus(7)
        swithCaseAddTaskFunction('dependencies')
        history.push(
          `/project/${id}/sprintflow/${props.funcsetIdChart}/subtask/${idsubtask}/dependencies`,
        )
      }
    }
  }
  const [switchAddTaskComponents, setSwitchAddTaskComponents] = useState(
    initialState.switchAddTaskComponents,
  )

  const swithCaseAddTaskFunction = (type) => {
    setSwitchAddTaskComponents(type)
  }

  let rolesupportneed = false
  if (rolee == true || checkCanEditProjectByStatus == true) {
    rolesupportneed = true
  }
  const renderComponents = (type) => {
    switch (switchAddTaskComponents) {
      case 'subassignee':
        return (
          <SubAssignee
            swithCaseAddTaskFunction={swithCaseAddTaskFunction}
            setModalVisionAddTask={setModalVisionAddTask}
            handleCancelAddTask={handleCancelAddTask}
            id={props.id}
            idsubtask={idsubtask}
            handleOkAddTask={handleOkAddTask}
            role={rolee}
            idEditPRJ={idEditPRJ}
            // idchart={props.funcsetIdChart + '_sub'}
          />
        )
      case 'subchecklist':
        return (
          <SubChecklist
            canclemodal={canclemodal}
            setCheckbtn={setCheckbtn}
            handleCancelAddTask={handleCancelAddTask}
            swithCaseAddTaskFunction={swithCaseAddTaskFunction}
            id={props.id}
            idsubtask={idsubtask}
            handleOkAddTask={handleOkAddTask}
            role={rolee}
            idEditPRJ={idEditPRJ}
          />
        )
      case 'subsupportneed':
        return (
          <SubSupportNeed
            memberRole={memberRole}
            swithCaseAddTaskFunction={swithCaseAddTaskFunction}
            setModalVisionAddTask={setModalVisionAddTask}
            handleCancelAddTask={handleCancelAddTask}
            id={props.id}
            idsubtask={idsubtask}
            handleOkAddTask={handleOkAddTask}
            role={rolesupportneed}
            idEditPRJ={idEditPRJ}
            checkStatusWaiting={checkStatusWaiting}
            // idchart={props.funcsetIdChart + '_sub'}
          />
        )
      case 'subkpifinance':
        return (
          <SubKPIFinance
            canKPIFinance={canKPIFinance}
            swithCaseAddTaskFunction={swithCaseAddTaskFunction}
            setModalVisionAddTask={setModalVisionAddTask}
            handleCancelAddTask={handleCancelAddTask}
            id={props.id}
            idsubtask={idsubtask}
            handleOkAddTask={handleOkAddTask}
            role={rolee}
            idEditPRJ={idEditPRJ}
            // idchart={props.funcsetIdChart + '_sub'}
            statusProject={statusProject}
          />
        )
      case 'dependencies':
        return (
          <Dependencies
            sprintflowId={idsubtask}
            projectId={idEditPRJ}
            taskStatus={subTaskStatus}
          />
        )
      default:
        return (
          <SubInformation
            canclemodal={canclemodal}
            setCheckbtn={setCheckbtn}
            handleCancelAddTask={handleCancelAddTask}
            swithCaseAddTaskFunction={swithCaseAddTaskFunction}
            id={props.id}
            idsubtask={idsubtask}
            handleOkAddTask={handleOkAddTask}
            idchart={props.funcsetIdChart + '_sub'}
            role={rolee}
            idEditPRJ={idEditPRJ}
            getDataSubTask={getDataSubTask}
            setChangePageInformation={setChangePageInformation}
            setChangePageInformation2={setChangePageInformation2}
            GetName={GetName}
            checkPlandateTaskSubTask={checkPlandateTaskSubTask}
            checkChangeFlow={checkChangeFlow}
            setCheckChangeFlow={setCheckChangeFlow}
            fullyCheckComplete={fullyCheckComplete}
          />
        )
    }
  }

  //data sub task
  const getDataSubTask = async () => {
    await getResultSubTask({
      level_id: props.id,
      project_id: parseInt(idEditPRJ),
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          await setDataSubTask([])

          await setIsLoading(false)
          return true
        }
        if (status === 200) {
          await setDataSubTask(data)
          await setIsLoading(false)
        } else {
          setDataSubTask([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataSubTask([])
        setIsLoading(false)
        console.error(error)
      })
  }

  const getDataTask = async () => {
    getResultProjectList({
      project_id: parseInt(idEditPRJ),
      id_chart: props.funcsetIdChart,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          await setDataTask([])
          setIsLoading(false)
          return true
        }
        if (status === 200) {
          setDataTask(data)
        } else {
          setDataTask([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataTask([])
        setIsLoading(false)
        console.error(error)
      })
  }

  useEffect(() => {
    if (token) {
      getDataSubTask()
      getDataTask()
    }
    renderComponents()
  }, [token])

  //copy Sprint flow
  const funcCopySubTask = (record) => {
    // console.log(record)
    if (roleold == true) {
    } else {
      setDataCopy(record.key)
      setVisibleModalCopy(true)
      // setCodeSubTask(record.alldata.code)
    }
  }

  //delete sprintflow
  const funcdeleteSprintflow = (record) => {
    if (roleold == true) {
    } else {
      setVisibleModalDelete(true)
      setDataDelete(record)
    }
  }
  const handleOkDelete = () => {
    // console.log(dataDelete)
    const dataArrayDeleteSprintflow = {
      project_id: parseInt(idEditPRJ),
      sprintflow_id: dataDelete.key,
    }
    try {
      deleteSprintFlow({
        params: dataArrayDeleteSprintflow,
        token: token,
      }).then((response) => {
        if (response.status === 200) {
          setVisibleModalDelete(false)
          getDataSubTask()
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  //table sub task
  const dataSource = dataSubTask.map((item) => ({
    key: item.id,
    name: item.title,
    plannedStart: item.plan_start,
    plannedEnd: item.plan_end,
    alldata: item,
    status: item.flow_status,
    code: item.code,
  }))
  const columns = [
    {
      title: 'Sub Task Name',
      dataIndex: 'name',
      key: 'name',
      // width: 300,
      ellipsis: true,
    },
    {
      title: 'Planned date',
      dataIndex: 'plannedDate',
      key: 'plannedDate',
      // width: 200,
      // align: 'center',
      ellipsis: true,
      render: (text, record) => {
        if (record.plannedStart == '' || record.plannedStart == '0000-00-00') {
          return (
            <Space style={{ paddingLeft: 40 }}>
              <p>-</p>
            </Space>
          )
        } else {
          return (
            <Space>
              <p>
                {moment(record.plannedStart).format('DD/MM/YYYY')} -{' '}
                {moment(record.plannedEnd).format('DD/MM/YYYY')}
                {/* {record.plannedStart} - {record.plannedEnd} */}
              </p>
            </Space>
          )
        }
      },
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      // width: 230,
      ellipsis: true,
      align: 'center',
      render: (status) => {
        return (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <div
              className={`Status  ${
                status === 'To Do'
                  ? 'status-ToDo'
                  : status === 'Done'
                  ? 'status-Done'
                  : status === 'In Progress'
                  ? 'status-InProgress'
                  : status === 'Done(delayed)'
                  ? 'status-Done-Delayed'
                  : status === 'In Progress(delayed)'
                  ? 'status-InProgress-Delayed'
                  : 'status-Done-Delayed'
              }`}
            >
              {status}
            </div>
          </div>
        )
      },
    },
    {
      title: '',
      key: 'action',
      render: (text, record) => {
        if (text.status == 'Done') {
          return (
            <Space
              size="middle"
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                paddingRight: 32,
              }}
            >
              <a>
                <EditOutlined
                  id="edit"
                  style={{ color: '#7C7C84' }}
                  onClick={() => EventUseModal(record.alldata, true)}
                />
              </a>

              <a>
                <CopyOutlined
                  id="copy"
                  style={{ color: '#7C7C84' }}
                  onClick={() => funcCopySubTask(record)}
                />
              </a>
            </Space>
          )
        } else {
          let disablecopy
          if (text.plannedStart == '') {
            disablecopy = true
          } else {
            disablecopy = false
          }

          return (
            <Space
              size="middle"
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                paddingRight: 32,
              }}
            >
              <a>
                <EditOutlined
                  id="edit"
                  style={{ color: '#7C7C84' }}
                  onClick={() => EventUseModal(record.alldata, false)}
                />
              </a>
              <a>
                <DeleteOutlined
                  id="delete"
                  style={{ color: '#7C7C84' }}
                  onClick={() => funcdeleteSprintflow(record)}
                />
              </a>
              <a hidden={disablecopy}>
                <CopyOutlined
                  id="copy"
                  style={{ color: '#7C7C84' }}
                  onClick={() => funcCopySubTask(record)}
                />
              </a>
            </Space>
          )
        }
      },
    },
  ]

  //check empty sub task
  const CheckDataSource = (dataSource, dataTask) => {
    if (dataTask.plan_start == '') {
      NoticicationTaskDate('warning')
    }
    if (dataSource == '' || dataTask == '') {
      if (
        // (role == true && roleold == true) ||
        dataTask.plan_start == '' ||
        roleold == true
      ) {
        return (
          <Col style={{ textAlign: 'center', paddingTop: 114 }}>
            <img style={{ width: 84, height: 86 }} src={bin}></img>

            <h2
              style={{
                paddingLeft: 240,
                color: 'rgba(18, 126, 195, 0.32)',
                paddingTop: 24,
              }}
            >
              Please create Sub Task in your project (optional)
            </h2>

            <div style={{ paddingTop: 32 }}>
              <Button
                disabled
                className="BTN_Next"
                onClick={() => EventUseModalAddTitle()}
              >
                <PlusOutlined id="createsubtask" className="Icon-color" />
                Create SubTask
              </Button>
            </div>
          </Col>
        )
      } else {
        return (
          <Col
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              paddingTop: 114,
            }}
          >
            <img style={{ width: 84, height: 86 }} src={bin}></img>
            <h2
              style={{
                // paddingLeft: 240,
                color: 'rgba(18, 126, 195, 0.32)',
                paddingTop: 24,
              }}
            >
              Please create Sub Task in your project (optional)
            </h2>

            <div style={{ paddingTop: 32 }}>
              <Button className="BTN_Next" onClick={() => EventUseModalAddTitle()}>
                <PlusOutlined id="createsubtask" className="Icon-color" />
                Create SubTask
              </Button>
            </div>
          </Col>
        )
      }
    } else {
      if (
        // (role == true && roleold == true) ||
        dataTask.plan_start == '' ||
        roleold == true
      ) {
        return (
          <div>
            <Row justify="end" style={{ marginTop: 32 }}>
              <Button
                id="createsubtask"
                disabled
                className="BTN_Next"
                onClick={() => EventUseModalAddTitle()}
              >
                <PlusOutlined className="Icon-color" />
                Create SubTask
              </Button>
            </Row>

            <Table
              className="Table tablesprinttask "
              style={{ marginTop: 32 }}
              dataSource={dataSource}
              columns={columns}
              pagination={false}
            />
          </div>
        )
      } else {
        return (
          <div style={{ minHeight: '35vh' }}>
            <Row justify="end" style={{ marginTop: 32 }}>
              <Button
                id="createsubtask"
                className="BTN_Next"
                onClick={() => EventUseModalAddTitle()}
              >
                <PlusOutlined className="Icon-color" />
                Create SubTask
              </Button>
            </Row>

            <Table
              className="Table tablesprinttask "
              style={{ marginTop: 32 }}
              dataSource={dataSource}
              columns={columns}
              pagination={false}
            />
          </div>
        )
      }
    }
  }

  const GetName = () => {
    if (idsubtask) {
      getResultProjectList({
        project_id: parseInt(idEditPRJ),
        id_chart: idsubtask,
        token: token,
      })
        .then(async (response) => {
          const { status, data, error } = response

          if (error) {
            setIsLoading(false)
            return true
          }
          if (status === 200) {
            setNameSubTask(data.title)
            setSubTaskStatus(data.flow_status)
            setIsLoading(false)
          } else {
            setIsLoading(false)
            return true
          }
        })
        .catch((error) => {
          setIsLoading(false)
          console.error(error)
        })
    }
  }

  useEffect(() => {
    if (idsubtask) {
      GetName()
    }
  }, [idsubtask])

  return (
    <Container>
      {CheckDataSource(dataSource, dataTask)}
      <Row justify="end" style={{ paddingTop: 245 }}>
        {/* <Button
          className="BTN_Previous"
          style={{
            marginRight: 7,
          }}
          onClick={() => swithCaseTaskFLowFunction('')}
        >
          <h4 style={{ color: '#127EC3' }}>Cancel</h4>
        </Button>

        <Button className="BTN_Next" htmlType="submit">
          <h4 style={{ color: 'white' }}>Save</h4>
        </Button> */}
      </Row>

      <Modal
        maskClosable={false}
        destroyOnClose={true}
        title={<h2 style={{ color: '#127EC3' }}>Add Sub Task</h2>}
        visible={ModalVisionAddTitle}
        onOk={form.submit}
        onCancel={handleCancelAddTitle}
        okText="Save"
        className="ModalAddTask"
      >
        <Form form={form} name="initsubtask" onFinish={handleOkAddTitle}>
          <Form.Item
            name="namesubtask"
            rules={[
              {
                whitespace: true,
                required: true,
                message: word['addsubtask_information_Name'],
              },
            ]}
          >
            <Input
              id="namesubtask"
              style={{ borderRadius: 5 }}
              placeholder="Name"
              name="item"
              type="text"
              maxLength="60"
              minLength="5"
              size="large"
            ></Input>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        maskClosable={false}
        destroyOnClose={true}
        // style={{ maxWidth: 100 }}
        title={
          <Row>
            <h2>
              {word['addtask_title_sub_keyaction']} : {showCode}
            </h2>

            <h2 className="clutter" style={{ marginLeft: '8px' }}>
              {nameSubTask}
            </h2>
          </Row>
        }
        visible={ModalVisionAddTask}
        onOk={handleOkAddTask}
        onCancel={() => handleCancelAddTask()}
        okText="Save"
        className="ModalRegister layout-maxwidth"
      >
        <Bodier className="Bodier2" style={{ width: '100%', marginTop: 16 }}>
          <div className="tab">
            <div
              id="Information"
              className={mode && OneUnitFocus == 1 ? 'Tabbar' : 'active-Tabbar'}
              onClick={() => handleSelect(1)}
            >
              <h3>{word['addtask_tab_information']}</h3>
            </div>
            <div
              id="Assignee"
              className={mode && OneUnitFocus == 3 ? 'Tabbar' : 'active-Tabbar'}
              onClick={() => handleSelect(3)}
            >
              <h3>{word['addtask_tab_assignee']}</h3>
            </div>
            <div
              id="KPI/Finance"
              className={mode && OneUnitFocus == 5 ? 'Tabbar' : 'active-Tabbar'}
              onClick={() => handleSelect(5)}
            >
              <h3>{word['addtask_tab_kpi']}</h3>
            </div>
            <div
              id="Check List"
              className={mode && OneUnitFocus == 2 ? 'Tabbar' : 'active-Tabbar'}
              onClick={() => handleSelect(2)}
            >
              <h3>{word['addtask_tab_checklist']}</h3>
            </div>
            <div
              id="Support Need"
              className={mode && OneUnitFocus == 4 ? 'Tabbar' : 'active-Tabbar'}
              onClick={() => handleSelect(4)}
            >
              <h3>{word['addtask_tab_supportneed']}</h3>
            </div>
            <div
              id="Dependencies"
              className={mode && OneUnitFocus == 7 ? 'Tabbar' : 'active-Tabbar'}
              onClick={() => handleSelect(7)}
            >
              <h3>Dependencies</h3>
            </div>
          </div>
        </Bodier>

        <div className="a">{renderComponents()}</div>
      </Modal>

      <Modal
        maskClosable={false}
        className="DeleteModal"
        visible={visibleModalDelete}
        okText={'Delete'}
        onOk={handleOkDelete}
        onCancel={() => setVisibleModalDelete(false)}
      >
        <CloseCircleOutlined className="CloseCircleOutlined" />
        <h2>{word['addtask_modaldelete_subtask_title']}</h2>

        <h4>{word['addtask_modaldelete_subtask_des']}</h4>
      </Modal>

      <ModalCopy
        visibleModalCopy={visibleModalCopy}
        setVisibleModalCopy={setVisibleModalCopy}
        type={'subtask'}
        id_project={dataCopy}
        refreshPage={getDataSubTask}
        role={rolee}
        idEditPRJ={idEditPRJ}
        Setmode={Setmode}
        setOneUnitFocus={setOneUnitFocus}
        swithCaseAddTaskFunction={swithCaseAddTaskFunction}
        setModalVisionAddTask={setModalVisionAddTask}
        setIDSubtask={setIDSubtask}
        setShowCode={setShowCode}
        idTask={props.id}
      />
    </Container>
  )
}
export default CreateProjectStep6
